import "./App.css";
import Header from "./Components/Header";
import Body from "./Components/Body";
function App() {
  return (
    <>
      <Header />
      <Body />
    </>
  );
}

export default App;
